import type { ICartReferenceProvider } from "../../application/interfaces/ICartReferenceProvider";

export class LocalStorageCartReferenceProvider implements ICartReferenceProvider {
    readonly localeStorageName = "tsm_cart_reference"

    async getReference(): Promise<string|null> {
        return localStorage.getItem(this.localeStorageName)
    }
    async saveReference(reference: string): Promise<void> {
        localStorage.setItem(this.localeStorageName, reference)
    }
    async clearReference():Promise<void> {
        localStorage.removeItem(this.localeStorageName)
    }
}